import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'

import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatTableModule, MatTableDataSource } from '@angular/material/table'
import { MatCheckboxModule } from '@angular/material/checkbox'

import { NgIf } from '@angular/common'
import { rotuloStatusEscala } from '../../utils/utils'

@Component({
  selector: 'table-list-purchase-reservation-service-order',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatTableModule,
    MatCheckboxModule,
    NgIf,
  ],
  templateUrl: './table-list-purchase-reservation-service-order.component.html',
  styleUrl: './table-list-purchase-reservation-service-order.component.scss',
})
export class TableListPurchaseReservationServiceOrderComponent
  implements OnInit, OnChanges
{
  constructor() {}

  @Input() dataSource: any[] = []
  @Input() columns: any[] = []
  @Input() selectedIds: string[] = []
  @Input() selectionIdField = 'cosId'
  @Output() editItem = new EventEmitter<any>()
  @Output() copyLinkItem = new EventEmitter<any>()
  @Output() sendEmailItem = new EventEmitter<any>()
  @Output() sendToFleet = new EventEmitter<any>()
  @Output() toggleSelectItem = new EventEmitter<any>()
  @Output() toggleSelectAll = new EventEmitter<boolean>()

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()
  rotuloStatusEscala = rotuloStatusEscala

  get allSelected(): boolean {
    return (
      this.dataSource.length > 0 &&
      this.dataSource.every((item: any) =>
        this.selectedIds.includes(item[this.selectionIdField]),
      )
    )
  }

  get someSelected(): boolean {
    return (
      this.dataSource.some((item: any) =>
        this.selectedIds.includes(item[this.selectionIdField]),
      ) && !this.allSelected
    )
  }

  ngOnInit() {
    this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
    this.tableSource = new MatTableDataSource<any>(this.dataSource)
  }

  ngOnChanges() {
    this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
    this.updateTableDataSource()
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
  }

  editItemEvent(item: any): void {
    this.editItem.emit(item)
  }

  copyLinkItemEvent(item: any): void {
    this.copyLinkItem.emit(item)
  }

  sendEmailItemEvent(item: any): void {
    this.sendEmailItem.emit(item)
  }

  sendToFleetEvent(item: any): void {
    this.sendToFleet.emit(item)
  }

  toggleSelectItemEvent(item: any): void {
    this.toggleSelectItem.emit(item)
  }

  toggleSelectAllEvent(checked: boolean): void {
    this.toggleSelectAll.emit(checked)
  }

  formatTime(time: string) {
    if (time) {
      const arrTime = time.split(':')
      if (arrTime.length > 1) {
        return `${arrTime[0]}:${arrTime[1]}`
      } else {
        return ''
      }
    } else {
      return ''
    }
  }
}
